import { gql, TypedDocumentNode } from '@apollo/client';

import { TimeRangeEnum } from '@libs/backend-common';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';

import { CurrencyType } from 'src/constants';
import { CoinMarketCapAsset } from 'src/types';

type AssetRateRecord = {
  valueAssetCode: string;
  range: TimeRangeEnum;
};

import { coinMarketCapFragment } from '../fragments';

export type GetAssetCmcInfoRes = {
  getAssetCmCInfo: DefaultApiResponse<CoinMarketCapAsset>;
};

export type CmcInfoArgs = {
  code: CurrencyType;
};

type GetAssetCmcInfoArgs = DefaultArg<CmcInfoArgs> & {
  changeRecord: AssetRateRecord;
};

export const getAssetCmcInfoQuery: TypedDocumentNode<
  GetAssetCmcInfoRes,
  GetAssetCmcInfoArgs
> = gql`
  query GetAssetCmCInfo(
    $record: GetAssetRecord!
    $changeRecord: AssetsRateRecord!
  ) {
    getAssetCmCInfo(record: $record) {
      ...coinMarketCapFields
      changePercentage(record: $changeRecord)
    }
  }

  ${coinMarketCapFragment}
`;
